const cache = new Map<string, string>();

export const getDecimalSeparator = (languageCode: string): string => {
  const cached = cache.get(languageCode);
  if (cached) return cached;

  // The 'en-US' fallback in the locale array applies only to
  // well-formed-but-unsupported tags. Malformed locale strings still throw
  // RangeError — callers must either pre-normalize or catch.
  const formatter = new Intl.NumberFormat([languageCode, 'en-US']);
  const parts = formatter.formatToParts(1.5);
  const result = parts.find(p => p.type === 'decimal')?.value ?? '.';

  cache.set(languageCode, result);
  return result;
};
